import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { Layout } from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

import content from '../../public/assets/markdown/health-score.md'

const HealthScorePage: NextPage = () => {
  const { t } = useTranslation()
  return (
    <Layout
      seo={{
        title: 'How Nutria Health Score Works | Nutria',
        description: t('cl_landing_health_score_meta_description'),
      }}
    >
      <MarkdownContentRenderer content={content} />
    </Layout>
  )
}

export default HealthScorePage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
